import React, { useState, useEffect } from 'react'
import {
  InputHLPure,
  TooltipHLPure,
  CheckBoxHLPure,
  SearchBarHLPure,
  ButtonAddHLPure,
  InstructionsPure,
  DropDownBtnHLPure,
  InteractiveDialog,
  GridSelectionHLPure,
} from '../../pures'
import { useMediaQuery } from '@material-ui/core'

const INFO_TYPE_DOCUMENT = Number(process.env.REACT_APP_INFO_TYPE_DOCUMENT)

const HeaderColumns = (props) => {
  return (
    <span className={(props.title === props.t('digitalVaultUploadView.grid.title.1') || props.title === props.t('digitalVaultUploadView.modal.entities.grid.title.1')) ? 'grid-header-one' : 'grid-headers'}>{props.title}</span>
  )
}

const CellColumnOne = (props) => {
  const { dataItem, t } = props

  return (
    <td className={`digitalVaultUploadView-col1 ${dataItem.selected ? 'selected' : ''}`}>
      <div>
        <p className='grid-cell-titles-margin-left grid-cell-title'>{dataItem.name}</p>
        <p className='grid-cell-titles-margin-left-thirdParty grid-cell-subtitle'>
          {t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.freeRequest')}
        </p>
      </div>
    </td>
  )
}

const CellDocumentWithCheckbox = (props) => {
  const { dataItem, onCheckChange } = props

  return (
    <td>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 0' }}>
        <CheckBoxHLPure
          valueCheckBox={dataItem}
          checkedState={dataItem.checked || false}
          onChangeHandler={(event) => onCheckChange(event, dataItem)}
        />
        <div>
          <p className='grid-cell-titles-margin-left-thirdParty-title grid-cell-title'>{dataItem.documentName}</p>
          <p className='grid-cell-titles-margin-left-thirdParty grid-cell-subtitle'>{dataItem.documentType}</p>
        </div>
      </div>
    </td>
  )
}

/**
 * @function DocumentListDialog
 * @description Modal para configurar la lista de documentos para un usuario específico
 * @param {{
 *   t: function,
 *   uploadData: {infoType: number, name: string, uploadedFiles: Array, description: string},
 *   selectedUserForList: {name: string, email: string}|null,
 *   showDocumentListDialog: boolean,
 *   setShowDocumentListDialog: function,
 *   setSelectedUserForList: function,
 *   selectedUsers: Array,
 *   secondApprovalUser: any,
 *   setSecondApprovalUser: function,
 *   skip: number,
 *   widthColumnOne: string,
 *   widthColumnFive: string,
 *   heightGrid: string
 * }} props
 * @returns {JSX.Element|null}
 */
const DocumentListDialog = (props) => {
  const {
    t,
    uploadData,
    selectedUserForList,
    showDocumentListDialog,
    setShowDocumentListDialog,
    setSelectedUserForList,
    selectedUsers,
    secondApprovalUser,
    setSecondApprovalUser,
    skip,
    heightGrid,
    documentGroups = [],
    documentTemplates = [],
    userDocumentLists = {},
    onSaveDocumentList,
  } = props

  const [documentsData, setDocumentsData] = useState([])
  const [selectedGroupId, setSelectedGroupId] = useState(null)
  const [customDocumentName, setCustomDocumentName] = useState('')
  const [customDocCounter, setCustomDocCounter] = useState(0)

  const AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />

  useEffect(() => {
    if (showDocumentListDialog && documentGroups.length > 0 && selectedGroupId === null) {
      setSelectedGroupId(documentGroups[0].id)
    }
  }, [showDocumentListDialog, documentGroups, selectedGroupId])


  const handleAddCustomDocument = () => {
    const trimmedName = customDocumentName.trim()
    if (!trimmedName) {
      return
    }

    if (trimmedName.length > 128) {
      return
    }

    const newCustomDoc = {
      id: `custom-${Date.now()}-${customDocCounter}`,
      documentName: trimmedName,
      documentType: t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.customDocument') || 'Personalizado',
      checked: false,
      isCustom: true
    }

    setDocumentsData(prev => [newCustomDoc, ...prev])
    setCustomDocCounter(prev => prev + 1)

    setCustomDocumentName('')
  }

  useEffect(() => {
    if (showDocumentListDialog && documentTemplates.length > 0) {
      const userEmail = selectedUserForList?.email
      const previouslySelectedDocs = userEmail ? (userDocumentLists[userEmail] || []) : []
      const previouslySelectedIds = previouslySelectedDocs.map(doc => doc.id)

      const existingCustomDocs = documentsData.filter(doc => doc.isCustom)

      const templateDocs = documentTemplates.map(doc => ({
        id: doc.id,
        documentName: doc.name,
        documentType: doc.groups && doc.groups.length > 0 ? doc.groups.map(g => g.name).join(', ') : '',
        groupIds: doc.groups && doc.groups.length > 0 ? doc.groups.map(g => g.id) : [],
        checked: previouslySelectedIds.includes(doc.id),
        isCustom: false
      }))

      setDocumentsData([...existingCustomDocs, ...templateDocs])
    }
  }, [showDocumentListDialog, documentTemplates, selectedUserForList, userDocumentLists])

  // Determinar si es modo documento (solo 1 documento) o expediente (múltiples)
  const isSingleDocumentMode = uploadData.infoType === INFO_TYPE_DOCUMENT
  const maxDocuments = isSingleDocumentMode ? 1 : null // null = sin límite
  const mobileResolution = useMediaQuery('(max-width:560px)')

  // Handler para cambiar el estado de checkbox de documentos
  const handleDocumentCheckChange = (event, document) => {
    if (isSingleDocumentMode) {
      // En modo documento, solo permitir 1 seleccionado
      // Si hace clic en el mismo documento, toggle; sino desmarcar todos y marcar solo el seleccionado
      setDocumentsData(prev => prev.map(doc => {
        if (doc.id === document.id) {
          return { ...doc, checked: !doc.checked }
        } else {
          return { ...doc, checked: false }
        }
      }))
    } else {
      // En modo expediente, permitir múltiples - toggle normal
      setDocumentsData(prev => prev.map(doc =>
        doc.id === document.id ? { ...doc, checked: !doc.checked } : doc
      ))
    }
  }

  const handleGroupChange = (e) => {
    const value = e?.target?.value || e?.target?.id || e
    setSelectedGroupId(value)
  }

  const groupOptions = documentGroups.map(g => ({ id: g.id, name: g.name }))
  const [searchValue, setSearchValue] = useState('')
  const handleSearchChange = (e) => {
    const value = e?.target?.value || ''
    setSearchValue(value)
  }

  let filteredDocuments = documentsData

  if (selectedGroupId) {
    filteredDocuments = filteredDocuments.filter(doc =>
      doc.isCustom || (doc.groupIds && doc.groupIds.includes(Number(selectedGroupId)))
    )
  }

  const filteredDocumentsBySearch = searchValue.trim()
    ? filteredDocuments.filter(doc =>
      doc.documentName?.toLowerCase().includes(searchValue.toLowerCase()) ||
      doc.documentType?.toLowerCase().includes(searchValue.toLowerCase())
    )
    : filteredDocuments

  if (!showDocumentListDialog || !selectedUserForList) {
    return null
  }

  return (
    <InteractiveDialog
      title={`${t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.documentList')}`}
      dialogSize='M'
      onClose={() => {
        setShowDocumentListDialog(false)
        setSelectedUserForList(null)
        setSelectedGroupId(null)
        setSearchValue('')
      }}
      saveBtnTitle={t('button.save')}
      cancelBtnTitle={t('button.cancel')}
      onSave={() => {
        const selectedDocs = documentsData
          .filter(doc => doc.checked)
          .map(doc => ({
            id: doc.isCustom ? null : doc.id,
            name: doc.documentName
          }))
        if (onSaveDocumentList && selectedUserForList?.email) {
          onSaveDocumentList(selectedUserForList.email, selectedDocs)
        }
        setShowDocumentListDialog(false)
        setSelectedUserForList(null)
        setSelectedGroupId(null)
        setSearchValue('')
      }}
    >
      <InstructionsPure instructions={
        uploadData.infoType === INFO_TYPE_DOCUMENT ? (
          <>
            <span>{t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.description')}</span> <strong>{t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.description_strong')}</strong>
            <span>{t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.description_2')}</span> <strong>{t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.description_strong_2')}</strong>
          </>
        ) :
          ''
      } />
      <div>
        <label className="inputHLPure-label">{t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.list.documents.user')} <strong>{selectedUserForList.name}</strong></label>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <label className="inputHLPure-label">
            {t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.add.documents.from.group')}
          </label>
          <TooltipHLPure
            positionTooltip={'top'}
            titleTooltip={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.add.documents.from.group')}
            descriptionTooltip={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.add.documents.from.group.description')}
            informationIcon
          />
        </div>
        <DropDownBtnHLPure
          optionsDropDown={groupOptions}
          nameOption="name"
          valueItem="id"
          optionsValue={selectedGroupId}
          onDropDownChange={handleGroupChange}
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <label className="inputHLPure-label" >
            {t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.add.documents.from.group.document')}
          </label>
          <TooltipHLPure
            positionTooltip={'top'}
            titleTooltip={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.add.documents.from.group.document')}
            descriptionTooltip={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.add.documents.from.group.document.tooltip.description')}
            informationIcon
          />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <InputHLPure
            labelInput={''}
            inputActive
            styleInput={{ width: '95%' }}
            typeInput='text'
            characterLimit={128}
            valueInput={customDocumentName}
            handleChangeInput={(e) => setCustomDocumentName(e.target.value)}
            handleKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleAddCustomDocument()
              }
            }}
          />
          <div style={{ width: '100%' }}>
            <ButtonAddHLPure
              nameBtn={mobileResolution ? '' : t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.add.custom.document')}
              onClickBtn={handleAddCustomDocument}
              iconAdd
              customIcon=''
            />
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <SearchBarHLPure
          placeholder={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.search.placeholder')}
          searchValue={searchValue}
          onSearchChange={handleSearchChange}
        />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginLeft: '6px' }}>
        <CheckBoxHLPure
          checkedState={filteredDocumentsBySearch.length > 0 && filteredDocumentsBySearch.every(doc => doc.checked)}
          disabled={isSingleDocumentMode}
          onChangeHandler={(e) => {
            if (isSingleDocumentMode) {
              // En modo documento no permitir seleccionar todos
              return
            }
            const allChecked = e.target?.checked || false
            const filteredIds = filteredDocumentsBySearch.map(doc => doc.id)

            setDocumentsData(prev => prev.map(doc => {
              if (filteredIds.includes(doc.id)) {
                return { ...doc, checked: allChecked }
              }
              return doc
            }))
          }}
        />
        <span style={{ color: '#2C353C', fontSize: '14px', fontFamily: 'Quicksand', fontWeight: 600 }} >
          {t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.select.documents')}
        </span>
      </div>

      <GridSelectionHLPure
        skip={skip}
        take={4}
        pageable
        dataGrid={filteredDocumentsBySearch}
        noRecordsMessage={t('digitalVaultUploadView.modal.thirdPartyDocumentRequest.title.grid.no.documents')}

        cellColumnOne={(props) => <CellDocumentWithCheckbox {...props} onCheckChange={handleDocumentCheckChange} />}
        headerColumnOne={AllHeadersColumns}
        widthColumnOne={'auto'}
        minResizableWidth1={'auto'}

        styleGrid={{ height: heightGrid }}
        onSelectedItem={() => { }}
        setNameComponentUser={() => { }}
        setShowDetails={() => { }}
      />
    </InteractiveDialog>
  )
}

export default DocumentListDialog
